import { helper } from '@ember/component/helper';
import { toDate, formatInTimeZone } from 'date-fns-tz';
import { format as formatDateWithoutTimezone } from 'date-fns/format';

export function formatDate(
  value: Date | string,
  format: string,
  timezone?: string,
): string {
  try {
    const date = value instanceof Date ? value : toDate(value);

    return timezone
      ? formatInTimeZone(date, timezone, format)
      : formatDateWithoutTimezone(date, format);
  } catch {
    // in the test environment ember-intl mocks text(all of our rendered text goes through the ember-intl)
    // and instead of dates, ember-intl translation keys are passed
    // which throws an error, as text can't be formatted as dates
    return value as unknown as string;
  }
}

export function dateFormat([value, format, timezone]: [
  Date | string,
  string,
  string?,
]): string {
  return formatDate(value, format || 'EEE, MMM do', timezone);
}

export default helper(dateFormat);
